import { getQueryParams } from './getQueryParams.js';

export const getQueryParam = (name, search = undefined) =>
  getQueryParams(search)[name];